// Global store for logs that persists across component mounts/unmounts
import { LogEntry } from '../types';

class LoggerStore {
  private logs: LogEntry[] = [];
  private listeners: Set<(logs: LogEntry[]) => void> = new Set();
  private maxLogs = 1000;

  subscribe(listener: (logs: LogEntry[]) => void) {
    this.listeners.add(listener);
    // Immediately notify with current state
    listener([...this.logs]);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify() {
    this.listeners.forEach(listener => listener([...this.logs]));
  }

  addLog(log: LogEntry) {
    this.logs = [log, ...this.logs].slice(0, this.maxLogs);
    this.notify();
  }

  clearLogs() {
    this.logs = [];
    this.notify();
  }

  getLogs(): LogEntry[] {
    return [...this.logs];
  }
}

export const loggerStore = new LoggerStore();

